import React from "react";
import dots from "../../assets/dots.svg";
import logoPillar from "../../assets/Frame 21.svg";
import logoTwoPillar from "../../assets/Frame 427321896.svg"
import logoThreePillar from "../../assets/Frame 427321897.svg"
import "./overview.css";

const PillarsSection = () => {
  const pillars = [
    {
      icon: logoPillar,
      title: "Cut MTTR by 50%",
      desc: "Autonomous RCA accelerates issue resolution, reducing downtime and restoring critical services faster",
    },
    {
      icon: logoTwoPillar,
      title: "Lower Cloud Spend",
      desc: "FinOps-driven automation continuously optimizes resources, eliminating waste and trimming unnecessary infrastructure expenses",
    },
    {
      icon: logoThreePillar,
      title: "Enterprise-Grade Resilience",
      desc: "Ensure compliance, maximize uptime, and safeguard customer trust with secure, intelligent, and adaptive operations",
    }
  ];

  return (
    <section className="pillar-section">
      <div className="container">
        <div className="pillar-wrapper">
          {/* Heading */}
          <div className="pillar-heading">
            <div className="section-tag">
              <img src={dots} alt="dots" />
              <p>Key Benefits</p>
            </div>
            <h2>Reliability Without the Overhead</h2>
            <p>Autonomous RCA plus FinOps optimization keeps systems stable and efficient</p>
          </div>

          {/* Pillar Cards */}
          <div className="row pillar-wrapper">
            {pillars.map((pillar, index) => (
              <div
                className="col-12 col-sm-4 col-md-4 col-lg-4"
                key={index}
              >
                <div className="pillar-card">
                  <div>
                    <img src={pillar.icon} alt={pillar.title} />
                  </div>
                  <h3>{pillar.title}</h3>
                  <p>{pillar.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PillarsSection;
